import { lazy } from "react";

export const MainHelpView = lazy(() => import("./MainHelpView"));
export const BrandHelpCenter = lazy(() => import("./BrandHelpCenter"));
export const CreatorsHelpCenter = lazy(() => import("./CreatorsHelpCenter"));
